<template>
  <div v-if="user">


    <div class="columns">
      <div class="column is-half">
        
        <div class="columns">
          <!-- <div class="column is-one-fifth">
          </div> -->
          
          <div class="column" style="padding: 10%">

            <div><b>Personal data</b></div>
            <br>

            <section>
              <b-field label="Firstname" label-position="on-border">
                  <b-input v-model="user.profile.firstname" placeholder="first name"></b-input>
              </b-field>

              <b-field label="Name" label-position="on-border">
                  <b-input v-model="user.profile.name" placeholder="name"></b-input>
              </b-field>

              <b-field label="Phone" label-position="on-border">
                  <b-input v-model="user.profile.phone" placeholder="phone number"></b-input>
              </b-field>

              

              

              <b-field label="Description" label-position="on-border">
                  <b-input maxlength="200" type="textarea" v-model="user.profile.description"></b-input>
              </b-field>

              <!-- <b-field label="Company" label-position="on-border">
                  <b-input v-model="account.profile.aname" placeholder="company" disabled></b-input>
              </b-field> -->

              <hr> 
              <div><b>Account data</b></div>
              <br>
              <b-field label="Role" label-position="on-border">
                  <b-input v-model="user.profile.role" placeholder="role" disabled></b-input>
              </b-field>

              <b-field
                  label="Email" label-position="on-border"
                  type="is-success"
                  message="This email is valid">
                  <b-input type="email" placeholder="email"  
                      v-model="user.profile.email"
                      maxlength="30" disabled>
                  </b-input>
              </b-field>

              <b-field label="Username" label-position="on-border"
                  type="is-success"
                  message="This username is available">
                  <b-input v-model="user.profile.username" value="johnsilver" maxlength="30" disabled></b-input>
              </b-field>

              <b-field label="Password" label-position="on-border">
                  <b-input type="password"
                      value="iwantmytreasure"
                      v-model="user.profile.password"
                      password-reveal>
                  </b-input>
              </b-field>

              
            </section>

            <hr>

            <section>

                <div class="buttons my-center-horizontal" @click="saveProfile">
                  <!-- <a class="button is-primary" @click="save"> -->
                  <a class="button is-primary">
                    <strong>SAVE</strong>
                  </a>
                </div>

            </section>
          </div>

          <!-- <div class="column is-one-fifth">
          </div> -->

        </div>


      </div>
      <div class="column is-half">

        <div style="left: 50%">
          <!-- <img alt="Vue logo" src="@/assets/logo.png"> -->
          
          <!-- <img alt="JW pic" :src="imageUrl" /> -->

          <img alt="JW pic" :src="imageUrlfromEmail" />

          <!-- {{imageUrl}}
          {{imageUrlfromEmail}} -->


          <!-- <div class="buttons my-center-horizontal" >
            <a class="button is-primary">
              <strong>Update Picture</strong>
            </a>
          </div> -->

          <div>
            <b-field class="file">
                <b-upload v-model="user.profile.file">
                    <a class="button is-primary">
                        <b-icon icon="upload"></b-icon>
                        <span>Click to upload</span>
                    </a>
                </b-upload>
                <span class="file-name" v-if="user.profile.file">
                    {{ user.profile.file.name }}
                </span>
            </b-field>
          </div>

        </div>

        <!-- {{user}} -->
      </div>
    </div>

        

    
  
  </div>
</template>

<script>
  // import Login from "../../components/auth/Login";
  import { mapState } from 'vuex';
  import md5 from 'js-md5';

  export default {
    name: 'PersonalProfile',
    components: {
        // Login
    },
    data() {
      return  {
        // profile: {
        //   name: "Johnson",
        //   firstname: "Tony",
        //   phone: "+2421 548 755",
        //   company: "Tony Servis",
        //   role: "Tony Boss",
        //   email: "tony@johnson.com",
        //   username: "tonyjohnson",
        //   password: "somesekret",
        //   description: "Owner",
        //   file: null
        // }
      }
    },
    methods: {
      saveProfile () {
        console.log(this.profile)
        // window.alert(JSON.stringify(this.profile))
      }
    },
      
    computed: {
      // localComputed() {
      //   return {}
      // },
      imageUrl() {
        return "https://www.gravatar.com/avatar/"+this.user.profile.gravatar+"?size=200";
      },
      imageUrlfromEmail() {
        return "https://www.gravatar.com/avatar/"+md5(this.user.profile.email.trim())+"?size=200";
      },
      ...mapState(['user', 'account'])
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    .myheaderbar {
      height: 3em;
      line-height: 3em;
      background: lightgray;
      text-align: left;
      padding-left: 1em;
    }
    .mybuttons {
      justify-content: center;
    }
    .my-center-horizontal {
      display: block;
    }
</style>